import styled from 'styled-components'
import { Link as a } from 'react-router-dom'
import { Form } from 'formik'

export const Link = styled(a)`
  color: ${({ theme }) => theme.colors.blues.A800};
`

export const FormContainer = styled(Form)`
  width: 100%;
`
